import React, {Component, Fragment} from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import * as actions from '../../../../store/actions/index';

import config from '../../../../config';
import AWS from 'aws-sdk';

import withErrorHandler from '../../../../hoc/withErrorHandler/withErrorHandler';
import ConsoleLog from '../../../../hoc/ConsoleLog/ConsoleLog';
import axios from '../../../../services/axios-service';
import getS3ImageUrl from '../../../../lib/s3FileHandler';

import GalaxyStepper from '../../../../components/UI/GalaxyStepper/GalaxyStepper';
import Button from '../../../../components/UI/Button/Button';
import Modal from '../../../../components/UI/Modal/Modal';
import {SlotPickerDefault} from '../../../../shared/constants';

import SelectCandidatesStep1 from '../../../../components/UI/StepperContent/SelectCandidatesStep1/SelectCandidatesStep1';
import InterviewDetailsStep2 from '../../../../components/UI/StepperContent/InterviewDetailsStep2/InterviewDetailsStep2';
import DateTimeStep3 from '../../../../components/UI/StepperContent/DateTImeStep3/DateTImeStep3';
import ConfirmDetailsStep4 from '../../../../components/UI/StepperContent/ConfirmDetailsStep4/ConfirmDetailsStep4';
import { monthShortName, SelectionBoxDurations, InterviewTypeList } from '../../../../shared/constants';

import './RecruiterInterviewContainer.css';

class RecruiterInterviewContainer extends Component {

    state = {
        candidateData : [],
        currentStep: 4,
        current: this.props.date?this.props.date: new Date(),
        today: (this.props.date && this.props.date !== null) ? null :  new Date(),
        date: (this.props.date) ? this.props.date : new Date(),
        activeElementId:1,
        selectedSlots:[],
        ampm: "am",
        selectedCandidates: [],
        selectAllChecked: false,
        data: {
          jobId: '',
          interviewType: '',
          interviewDuration: '30 mins',
          interviewLocation: '',
          interviewMessage: '',
          interviewRecruiterMessage:'',
          userId: '',
          userName: '',
          candidateDetails:[],
          slotDetails:[],
          requestedBy: null,
          interviewAttachments:''
        },
        continueBtnDisabled: true,
        showModal: false,
        activeId: '',
        activeItem: '',
        slotsInvalid: false,
        candidateImage:null,
        candidateImageCount:0,
        slotsDisabled: false,
        currentInterviewDuration: '30 mins', 
        calendarFirstDate: true,
        confirmModal: false,
        sendToRecruiterBtn: true,
        sentToCandidateButton: false,
        highestStepper:4,
        disableNotesSection: true,
        jobTitle: '',
        showStep1Content: true,
        jobTitleBHID: '',
        progressPercent:{},
        deleteAttachFiles: [],
        overlappingSlots: [],
        pageDataLoss: false,
        nextPath: ''

    }

    componentDidMount(){
        // ConsoleLog('comp mounted', this.props);

        if(this.props.clientDetails){
            const data = {...this.state.data};
            data.userName = this.props.user.username;
            data.userId = parseInt(this.props.attributes["custom:userid"]);
            this.setState({data});
        }

        if(this.props.location.state.clientId){
            this.fetchInterviewDetails(this.props.location.state.clientId)
        }

        if(this.props.pageDataLoss){
          this.setState({pageDataLoss: this.props.pageDataLoss});
        }
    }

    componentDidUpdate(prevProps, prevState){
      if(this.props.pageDataLoss !== prevProps.pageDataLoss){
        this.setState({pageDataLoss: this.props.pageDataLoss, nextPath: this.props.nextPath})
      }
    }

    fetchProgressedCandidateList=(jobId)=>{
        axios.get("/galaxy/interview?jobId="+jobId+"&candidateList=1")
        .then((response) => {
         const clientInterviewData = response.data.candidates;
         let CandidateDataState = [...this.state.candidateData];
         const candidateData = clientInterviewData.map(candidate=>{
            getS3ImageUrl(candidate.candidate_image,this.props.user).then((url) => {
              candidate.s3SignedUrl =  url;
              this.setState({candidateImageCount: this.state.candidateImageCount + 1});
            }).catch(() => {
              this.setState({candidateImageCount: this.state.candidateImageCount + 1});
            })
            if(CandidateDataState.some(item => item.candidate_id === candidate.candidate_id)){
              this.setState({candidateImageCount: this.state.candidateImageCount - 1});
            }else{
              CandidateDataState.push(candidate);
            }
          })
          this.setState({candidateData:CandidateDataState, showStep1Content: true});
        })
        .catch((error) => {
          ConsoleLog(error);
          throw error;
        });
    }

    fetchInterviewDetails = (clientId) => {
        axios.get("/galaxy/interview/"+clientId)
        .then((response) => {
            // ConsoleLog("response notification",response.data);
            const clientInterviewData=response.data;
            if (clientInterviewData.client_interview_status == 'Completed') {
              this.props.history.push({
                pathname: '/recruiter/interview-view',
                state:{interviewId: clientId}
              });
            }
            const data = {...this.state.data};
            let selectedCandidates = [...this.state.selectedCandidates];
            const candidateData = clientInterviewData.candidates.map((candidate) => {
                getS3ImageUrl(candidate.candidate_image,this.props.user).then((url) => {
                    candidate.s3SignedUrl =  url;
                    this.setState({candidateImageCount: this.state.candidateImageCount + 1});
                }).catch(() => {
                    this.setState({candidateImageCount: this.state.candidateImageCount + 1});
                })
                selectedCandidates.push(candidate.candidate_id);
                return {id: candidate.candidate_id}
            })

            let duration = SelectionBoxDurations.filter(item => item.label === clientInterviewData.client_interview_duration);
            let activeElementId = duration[0].id;

            let interviewType = InterviewTypeList.filter(item => item.value.toLowerCase() === clientInterviewData.client_interview_type.toLowerCase());
            let activeId = interviewType[0].value;
            let activeItem = interviewType[0].value;

            const slotData = clientInterviewData.slots.map((item) => {
                const DateArray = item.slot.split('T');
                const dateData = DateArray[0];
                const timeArray = DateArray[1].split('.');
                const timeData = timeArray[0];
                const isAmPm = moment.utc(item.slot).format('a');
                let slot = '';
                if(clientInterviewData.client_interview_duration === "30 mins"){
                    slot = moment.utc(item.slot).format('hh:mm')+" - "+moment.utc(item.slot).add(30,'minutes').format('hh:mm');
                }else{
                    const durationArray = clientInterviewData.client_interview_duration.split(" ");
                    slot = moment.utc(item.slot).format('hh:mm')+" - "+moment.utc(item.slot).add(durationArray[0],'hours').format('hh:mm');
                }
                return { slotvalue: dateData+" "+timeData, date: new Date(item.slot), isAmPm: isAmPm, slot: slot}
            })

            const slotDataState = slotData.map((item) => {
                return {slot: item.slotvalue}
            });

            const current = clientInterviewData.slots.length > 0?new Date(clientInterviewData.slots[0].slot):new Date();
            data.interviewId = clientId.toString();
            data.jobId = clientInterviewData.job_id;
            data.jobBhId = clientInterviewData.job_bh_id;
            data.jobName = clientInterviewData.job_name;
            data.interviewMessage = clientInterviewData.client_interview_client_message;
            data.interviewDuration = clientInterviewData.client_interview_duration;
            data.interviewLocation = clientInterviewData.client_interview_location;
            data.interviewType = clientInterviewData.client_interview_type;
            data.requestedBy = clientInterviewData.requested_by;
            data.jobId = clientInterviewData.job_id;
            data.candidateDetails = candidateData;
            data.slotDetails = slotDataState;

            this.setState({
                data, 
                candidateData: clientInterviewData.candidates, 
                selectedSlots: slotData,
                selectedCandidates,
                activeElementId,
                activeId,
                activeItem,
                currentInterviewDuration: clientInterviewData.client_interview_duration,
                current,
                jobTitle: clientInterviewData.job_name,
                jobTitleBHID: clientInterviewData.job_bh_id
            });
        })
        .catch((error) => {
            ConsoleLog(error);
            throw error;
        });
    }

    loadData = (stepperId,currentStep) => {
    
        switch(stepperId) {
          case 1:
            this.setState({showStep1Content: false});
            this.fetchProgressedCandidateList(this.state.data.jobId);
            if(stepperId < currentStep){
              if(stepperId <= this.state.highestStepper){
                this.setState({currentStep:1,continueBtnDisabled: false})
              }else{
                this.setState({currentStep:1,continueBtnDisabled: true})
              }
            }
            break;
          case 2:
            if(stepperId < currentStep){
              if(stepperId <= this.state.highestStepper){
                this.setState({currentStep:2, continueBtnDisabled: false})
              }else{
                this.setState({currentStep:2, continueBtnDisabled: true})
              }
            }
            break;
          case 3:
            if(stepperId < currentStep){  
              if(stepperId <= this.state.highestStepper){
                this.setState({currentStep:3, continueBtnDisabled: false})
              }else{
                this.setState({currentStep:3, continueBtnDisabled: true})
              }
              this.setOverlappedSlots(this.state.selectedSlots);
            }
          break;
          case 4:
            if(stepperId < currentStep){
              if(stepperId <= this.state.highestStepper){
                this.setState({currentStep:4, continueBtnDisabled: false})
              }else{
                this.setState({currentStep:4, continueBtnDisabled: true})
              }
            }
          break;
          default:
            this.setState({currentStep:1})
        }
        
      }

      setOverlappedSlots = (selectedSlots) => {

        var fullDateArr = []; 
        const duration = this.state.data.interviewDuration;
        
        var fromDate1 = moment(SlotPickerDefault.startTime, "hmm");
        const durationValue1 = duration ==="30 mins" ? 0.5 : duration.split(' ')[0];
        for(let i=0;i<=11;i++) {
            fullDateArr.push(moment(fromDate1).format("HH:mm")  + " - " + moment(fromDate1).add(durationValue1, 'hours').format("HH:mm"));
            fromDate1 = moment(fromDate1).add(0.25, 'hours');
        }
        
        var fromDate2 = moment("1200", "hmm");
        const durationValue2 = duration === "30 mins" ? 0.5 : duration.split(' ')[0];
        const hours = Math.floor(SlotPickerDefault.endTime/100);
        const minutes = SlotPickerDefault.endTime%100;
        const loopTimes = ((hours*60)/15) + (minutes/15);
        for(let i=0;i<=loopTimes;i++) {
            fullDateArr.push(moment(fromDate2).format("HH:mm")  + " - " + moment(fromDate2).add(durationValue2, 'hours').format("HH:mm"));
            fromDate2 = moment(fromDate2).add(0.25, 'hours');
        }

        if(selectedSlots.length > 0){

          var overlappingSlots = [...this.state.overlappingSlots];

          selectedSlots.map((data) => {

            const isAmPm = data.isAmPm;

            var month = parseInt(data.date.getMonth()+1);
            var day = parseInt(data.date.getDate());

            if((parseInt(data.date.getMonth()+1)) < 10 ){
              month = "0"+parseInt(data.date.getMonth()+1);
            }
            if((parseInt(data.date.getDate())) < 10 ){
              day = "0"+parseInt(data.date.getDate());
            }

            var currentSelectedDateFormat = data.date.getFullYear() +"-"+ month + "-" + day;
            const splitTime = data.slot.split(" - ");
            const currentStartTime = splitTime[0];
            const startTimeDetail = currentStartTime.split(':');
            let startHour = startTimeDetail[0];
            const startMinutes = startTimeDetail[1];
    
            if(isAmPm === "pm"){
              if(startTimeDetail[0] !== '12'){
                startHour = parseInt(startTimeDetail[0])+12;
              }
            }
    
            const currentEndTime = splitTime[1];
            const endTimeDetail = currentEndTime.split(':');
            let endHour = endTimeDetail[0];
            const endMinutes = endTimeDetail[1];
    
            if(isAmPm === "pm"){
              if(endTimeDetail[0] !== '12'){
                endHour = parseInt(endTimeDetail[0])+12;
              }
            }else{
              if(parseInt(endTimeDetail[0]) < 9){
                endHour = parseInt(endTimeDetail[0])+12;
              }
            }

            let currentStartTimetoDate =  moment(currentSelectedDateFormat);
            currentStartTimetoDate = currentStartTimetoDate.set({h:startHour, m: startMinutes});
    
            let currentEndTimetoDate =  moment(currentSelectedDateFormat);
            currentEndTimetoDate = currentEndTimetoDate.set({h:endHour, m: endMinutes});

            var currentSelectedDateFormatted = data.date.getDate() +"-" + parseInt(data.date.getMonth()+1) + "-" + data.date.getFullYear();

            fullDateArr.map((dateitem) => {
          
              let dateArrSplit = dateitem.split(' - ');
              let dateArrStartTime = dateArrSplit[0];
    
              let dateArrStartTimeDetails = dateArrStartTime.split(':');
              let dateArrStartTimeHour = dateArrStartTimeDetails[0];

              let dateArrStartTimeMinutes = dateArrStartTimeDetails[1];
    
              let dateArrEndTime = dateArrSplit[1];
    
              let dateArrEndTimeDetails = dateArrEndTime.split(':');
              let dateArrEndTimeHour = dateArrEndTimeDetails[0];
              let dateArrEndTimeMinutes = dateArrEndTimeDetails[1];
    
              let thisStartTimetoDate =  moment(currentSelectedDateFormat);
              thisStartTimetoDate = thisStartTimetoDate.set({h:dateArrStartTimeHour, m: dateArrStartTimeMinutes});
    
              let thisEndTimetoDate =  moment(currentSelectedDateFormat);
              thisEndTimetoDate = thisEndTimetoDate.set({h:dateArrEndTimeHour, m: dateArrEndTimeMinutes});

              if(currentStartTimetoDate.isBetween(thisStartTimetoDate,thisEndTimetoDate)){
                overlappingSlots.push({ time: dateitem, date: currentStartTimetoDate, forSlotDate: moment(currentStartTimetoDate).format('DD-MM-YYYY'), forSlot: data.slot});
              }else{
                //console.log(currentStartTimetoDate+' is not between '+thisStartTimetoDate+' and '+thisEndTimetoDate)
              }
    
              if(currentEndTimetoDate.isBetween(thisStartTimetoDate,thisEndTimetoDate)){
                overlappingSlots.push({ time: dateitem, date: currentEndTimetoDate,forSlotDate: moment(currentEndTimetoDate).format('DD-MM-YYYY'),forSlot: data.slot });
              }else{
                //console.log(currentEndTimetoDate+' is not between '+thisStartTimetoDate+' and '+thisEndTimetoDate)
              }
            });

          })
          this.setState({overlappingSlots});

        }
      }
    
      getWeekDays = () => {
        const currentDay = this.state.date;
        const weekDay = (currentDay.getDay() === 0) ? 7 : currentDay.getDay();
        const prevWeek  = currentDay*1 - (weekDay-1)*24*3600*1000;
        const nextWeek  = currentDay*1 + (8-weekDay)*24*3600*1000;
      
        var oneDay = 24*3600*1000;
        for (var d=[],ms=prevWeek*1,last=nextWeek*1;ms<last;ms+=oneDay){
          d.push( new Date(ms) );
        }
        return d;
      }
    
      isSameDay = (date, basedate = new Date()) => {  
        //return false;
        if (!(this.isDate(date) && this.isDate(basedate))) return false;
        const basedateDate = basedate.getDate();
        const basedateMonth = +(basedate.getMonth()) + 1;
        const basedateYear = basedate.getFullYear();
        const dateDate = date.getDate();
        const dateMonth = +(date.getMonth()) + 1;
        const dateYear = date.getFullYear();
    
        return (+basedateDate === +dateDate) && (+basedateMonth === +dateMonth) && (+basedateYear === +dateYear);    
      }
    
      isDate = date => {
        const isDate = Object.prototype.toString.call(date) === '[object Date]';
        const isValidDate = date && !Number.isNaN(date.valueOf());
        
        return isDate && isValidDate;
      }
    
      handleNextWeek = (event) => {
        const date = this.state.date;
        const today = new Date();
        const weekDay = (date.getDay() === 0) ? 7 : date.getDay();
        const dateCopy = new Date(date.getFullYear()+'/'+parseInt(date.getMonth()+1)+'/'+date.getDate());
        const lastDayWeek  = new Date(dateCopy.setDate(dateCopy.getDate() + (7-weekDay)));
        //const maxDate = new Date(today.setDate(today.getDate() + ( /*this.props.maxWeeks*/ 2 * 7)));
        //if(maxDate > lastDayWeek) {   
          const nextWeek = new Date(date.setDate(date.getDate() + 7));
          this.setState({ date: nextWeek });
        //}
      }
    
      handlePreviousWeek = (event) => {
        const date = this.state.date;
        const today = new Date();
        const weekDay = (date.getDay() === 0) ? 7 : date.getDay();
        
        const dateCopy = new Date(date.getFullYear()+'/'+parseInt(date.getMonth()+1)+'/'+date.getDate());
        const firstDayWeek  = new Date(dateCopy.setDate(dateCopy.getDate() - (weekDay)));
      
        if(firstDayWeek > today) {
          const prevWeek = new Date(date.setDate(date.getDate() - 7));
          this.setState({ date: prevWeek });
        }
      }
    
      handlePreviousMonth = (event) => {
        event.preventDefault();
        if(!this.props.maxWeeks || this.props.maxWeeks > 4) {
          const date = this.state.date;
          const prevMonth = new Date(date.setMonth(date.getMonth() - 1));
          this.setState({ date: prevMonth });
        }
      }
    
      handleNextMonth = (event) => {
        event.preventDefault();
        if(!this.props.maxWeeks || this.props.maxWeeks > 4) {
          const date = this.state.date;
          const nextMonth = new Date(date.setMonth(date.getMonth() + 1));
          this.setState({ date: nextMonth });
        }
      }
    
      handleSelect = (selectedDate) => {
        const today = new Date();
        today.setHours(0);
        today.setMinutes(0);
        today.setSeconds(0);
      
        if(selectedDate >= today) {
          this.setState({ 
            current: selectedDate, 
            currentDate: this.handleDateFormat(selectedDate),
            today: null,
            calendarOpen: false
          });
          if(this.props.handleSelect){
            this.props.handleSelect(selectedDate);
          }
        }
        this.setState({slotsDisabled: false,calendarFirstDate: false});
      }
    
      handleDateFormat = (selectedDate) => {
        const format = this.props.format?this.props.format.toLowerCase():null;
        switch(format) {
          case 'dd/mm/yyyy' : 
            return selectedDate.getDate() +"/" + parseInt(selectedDate.getMonth()+1) + "/" + selectedDate.getFullYear();
          case 'mm/dd/yyyy' : 
            return parseInt(selectedDate.getMonth()+1) +"/" + selectedDate.getDate() + "/" + selectedDate.getFullYear();
          case 'dd mmm yyyy' : 
            return selectedDate.getDate() +" " + monthShortName[selectedDate.getMonth()] + " " + selectedDate.getFullYear();
          default: 
            return selectedDate.getDate() +"/" + parseInt(selectedDate.getMonth()+1) + "/" + selectedDate.getFullYear();
        }
      }
    
      handleAMPM = (data) => {
        this.setState({ampm: data});
      }
    
      timeSelect = (slotTimeRange, isAmPm, currentSelectedDate,dateArr,fullDateArr) => {
        
        var selectedSlots = [...this.state.selectedSlots];
        var data = {...this.state.data};

        var month = parseInt(currentSelectedDate.getMonth()+1);
        var day = parseInt(currentSelectedDate.getDate());
        if(currentSelectedDate){
          if((parseInt(currentSelectedDate.getMonth()+1)) < 10 ){
            month = "0"+parseInt(currentSelectedDate.getMonth()+1);
          }
          if((parseInt(currentSelectedDate.getDate())) < 10 ){
            day = "0"+parseInt(currentSelectedDate.getDate());
          }
    
        }

        var currentSelectedDateFormat = currentSelectedDate.getFullYear() +"-" + month + "-" + day;

        var overlappingSlots = [...this.state.overlappingSlots];
        const splitTime = slotTimeRange.split(" - ");
        const currentStartTime = splitTime[0];
        const startTimeDetail = currentStartTime.split(':');
        let startHour = startTimeDetail[0];
        const startMinutes = startTimeDetail[1];

        if(isAmPm === "pm"){
          if(startTimeDetail[0] !== '12'){
            startHour =  parseInt(startTimeDetail[0])+ 12;
          }
        }

        const currentEndTime = splitTime[1];
        const endTimeDetail = currentEndTime.split(':');
        let endHour = endTimeDetail[0];
        const endMinutes = endTimeDetail[1];

        if(isAmPm === "pm"){
          if(endTimeDetail[0] !== '12'){
           endHour = parseInt(endTimeDetail[0])+12;
          }
        }else{
          if(parseInt(endTimeDetail[0]) < 9){
            endHour = parseInt(endTimeDetail[0])+12;
          }
        }
        
        let currentStartTimetoDate =  moment(currentSelectedDateFormat);
        currentStartTimetoDate = currentStartTimetoDate.set({h:startHour, m: startMinutes});

        let currentEndTimetoDate =  moment(currentSelectedDateFormat);
        currentEndTimetoDate = currentEndTimetoDate.set({h:endHour, m: endMinutes});

        var currentSelectedDateFormatted = day +"-" + month+ "-" + currentSelectedDate.getFullYear();

        const array = this.state.selectedSlots && this.state.selectedSlots.some(item => {
          if(item.date.getDate()){
            var newDate = item.date.getDate();
            var newMonth = item.date.getMonth()+1;
            
            if(item.date.getDate() < 10){
              newDate = "0"+item.date.getDate();
            }
            if(item.date.getMonth()+1 < 10){
              newMonth = "0"+parseInt(item.date.getMonth()+1);
            }
    
            var final = newDate+"-"+newMonth+"-"+item.date.getFullYear();
            if(final === currentSelectedDateFormatted){
              if(item.slot === slotTimeRange){
                return true
              }
              return false;
            }else{
              return false;
            }
          }
        });

        if(this.state.selectedSlots && array === true){

          selectedSlots = selectedSlots.filter(function(el){
            var newDate = el.date.getDate();
            var newMonth = el.date.getMonth()+1;
            
            if(el.date.getDate() < 10){
              newDate = "0"+el.date.getDate();
            }
            if(el.date.getMonth()+1 < 10){
              newMonth = "0"+parseInt(el.date.getMonth()+1);
            }

            if(newDate +"-" + newMonth + "-" + el.date.getFullYear() === currentSelectedDateFormatted){
              if(el.slot === slotTimeRange){
                return false;
              }else{
                return true;
              }
            }else{
              return true;
            }
          }); 

          overlappingSlots = overlappingSlots.filter(item => !(item.forSlot === slotTimeRange && item.forSlotDate === currentSelectedDateFormatted))
          
          data.slotDetails = data.slotDetails.filter(item => selectedSlots.some(slot => slot.slotvalue === item.slot))
        }
        else {
          const startTime = slotTimeRange.split(' ');
          const startTimewithAmPm = startTime[0]+ " "+isAmPm;
          const finalStartTime = moment(currentSelectedDate).format('YYYY-MM-DD')+ " "+ moment(startTimewithAmPm,["h:mm a"]).format("HH:mm:ss");
          
          selectedSlots.push({slot: slotTimeRange, isAmPm: isAmPm,date: currentSelectedDate,slotvalue: finalStartTime});
          data.slotDetails.push({slot: finalStartTime});

          fullDateArr.map((item) => {
          
            let dateArrSplit = item.split(' - ');
            let dateArrStartTime = dateArrSplit[0];
  
            let dateArrStartTimeDetails = dateArrStartTime.split(':');
            let dateArrStartTimeHour = dateArrStartTimeDetails[0];
            let dateArrStartTimeMinutes = dateArrStartTimeDetails[1];
  
            let dateArrEndTime = dateArrSplit[1];
  
            let dateArrEndTimeDetails = dateArrEndTime.split(':');
            let dateArrEndTimeHour = dateArrEndTimeDetails[0];
            let dateArrEndTimeMinutes = dateArrEndTimeDetails[1];
  
            let thisStartTimetoDate =  moment(currentSelectedDateFormat);
            thisStartTimetoDate = thisStartTimetoDate.set({h:dateArrStartTimeHour, m: dateArrStartTimeMinutes});
  
            let thisEndTimetoDate =  moment(currentSelectedDateFormat);
            thisEndTimetoDate = thisEndTimetoDate.set({h:dateArrEndTimeHour, m: dateArrEndTimeMinutes});
         
            if(currentStartTimetoDate.isBetween(thisStartTimetoDate,thisEndTimetoDate)){
              overlappingSlots.push({ time: item, date: currentStartTimetoDate, forSlotDate: moment(currentStartTimetoDate).format('DD-MM-YYYY'), forSlot: slotTimeRange});
            }else{
              //console.log(currentStartTimetoDate+' is not between '+thisStartTimetoDate+' and '+thisEndTimetoDate)
            }
  
            if(currentEndTimetoDate.isBetween(thisStartTimetoDate,thisEndTimetoDate)){
              overlappingSlots.push({ time: item, date: currentEndTimetoDate,forSlotDate: moment(currentEndTimetoDate).format('DD-MM-YYYY'),forSlot: slotTimeRange });
            }else{
              //console.log(currentEndTimetoDate+' is not between '+thisStartTimetoDate+' and '+thisEndTimetoDate)
            }
          });

        }

        if(data.slotDetails.length > 0){
          this.setState({data,continueBtnDisabled:false,selectedSlots,overlappingSlots})
        }else{
          this.setState({data,continueBtnDisabled:true,selectedSlots,overlappingSlots})
        }
    
     }
    
      handleCandidateSelect = (candidateId) => {
          let selected = false;
          let selectedCandidates = [...this.state.selectedCandidates];
          let data = {...this.state.data};
          let disabled = true;
          if(this.state.selectedCandidates.some(item => item === candidateId)) {
            selectedCandidates = selectedCandidates.filter(candidate => candidate !== candidateId);
            data.candidateDetails = data.candidateDetails.filter(candidate => candidate.id !== candidateId);
            if(data.candidateDetails.length > 0){
              disabled = false;
            }else{
              disabled = true;
            }
          } else {
            selectedCandidates.push(candidateId);
            data.candidateDetails.push({id:candidateId});
            disabled = false;
          }
          this.setState({selectedCandidates,selectAllChecked: selected,data,continueBtnDisabled: disabled});
      }
    
      handleCheckbox = (event) => {
          let selectedCandidates = [];
          let data = {...this.state.data};
          if(event.target.checked === true){
            data.candidateDetails.length = 0;
            this.state.candidateData.map((candidate) => {
              selectedCandidates.push(candidate.candidate_id);
              data.candidateDetails.push({id:candidate.candidate_id});
            });
            this.setState({selectedCandidates,selectAllChecked: !this.state.selectAllChecked, data,continueBtnDisabled: false});
          }else{
            data.candidateDetails.length=0;
            this.setState({selectedCandidates,selectAllChecked: !this.state.selectAllChecked, data, continueBtnDisabled: true});
          }
      }
    
      handleContinue = () => {
        if(this.state.currentStep === 3){
          if(this.state.data.slotDetails.length >= this.state.data.candidateDetails.length){
            if(this.state.currentStep + 1 > this.state.highestStepper){
              this.setState({highestStepper: this.state.currentStep + 1});
            }
    
            if(this.state.currentStep < this.state.highestStepper){
              this.setState({currentStep: this.state.currentStep + 1, continueBtnDisabled: false, slotsInvalid:false});
            }else{
              this.setState({currentStep: this.state.currentStep + 1, continueBtnDisabled: true, slotsInvalid:false});
            }
          window.scrollTo(0,0);
          }else{
            this.setState({slotsInvalid:true});
          }

        }else{
          let slotcount = this.state.selectedSlots.length;
          if(this.state.currentStep == 2) {
            this.setOverlappedSlots(this.state.selectedSlots);
            if(this.state.currentInterviewDuration && this.state.currentInterviewDuration != this.state.data.interviewDuration) {
              let data = {...this.state.data};          
              data.slotDetails = [];
              this.setState({data: data, selectedSlots: [], overlappingSlots:[], current: new Date()});
              slotcount = 0;
            }
            let duration = this.state.data.interviewDuration;
            this.setState({currentInterviewDuration: duration});
          }
    
          if(this.state.currentStep + 1 > this.state.highestStepper){
            this.setState({highestStepper: this.state.currentStep + 1});
          }
    
          if(this.state.currentStep < this.state.highestStepper){
            if(this.state.currentStep === 1 ){
              let data = {...this.state.data};
              if(data.interviewLocation !== '' && data.interviewType !== '' && data.interviewDuration !== ''){
                this.setState({currentStep: this.state.currentStep + 1, continueBtnDisabled: false});
              }else{
                this.setState({currentStep: this.state.currentStep + 1, continueBtnDisabled: true});
              }
            }else if(this.state.currentStep === 2){
              if(slotcount === 0){
                this.setState({currentStep: this.state.currentStep + 1, continueBtnDisabled: true});
              }else{
                this.setState({currentStep: this.state.currentStep + 1, continueBtnDisabled: false});
              } 
            }else{
              this.setState({currentStep: this.state.currentStep + 1, continueBtnDisabled: false});
            } 
          }else{
            this.setState({currentStep: this.state.currentStep + 1, continueBtnDisabled: true});
          }
          window.scrollTo(0,0);
        }
      }
    
      handleInterviewDuration = (id, event) => {
        let duration = SelectionBoxDurations.filter(item => item.id === id);
        let data = {...this.state.data};
        data.interviewDuration = duration[0].label;
        if(this.state.data.interviewLocation.length > 0 && this.state.data.interviewType.length > 0){
          this.setState({activeElementId: id,data,continueBtnDisabled:false});
        }else{
          this.setState({activeElementId: id,data,continueBtnDisabled:true});
        }
      }
    
      handleInterviewLocation = (e) => { 
          let data = {...this.state.data};
          data.interviewLocation = e.target.value;
          if(data.interviewLocation.length > 0 && this.state.data.interviewType.length > 0){
            this.setState({continueBtnDisabled: false,data});
          }else{
            this.setState({continueBtnDisabled: true,data});
          }
      }
    
      handleItemChange = (e,value) => {
        e.preventDefault();
        let data = {...this.state.data};
        data.interviewType = value;
        if(data.interviewType.length >0 && this.state.data.interviewLocation.length > 0){
          this.setState({data,activeId:value,activeItem:value,continueBtnDisabled:false});
        }else{
          this.setState({data,activeId:value,activeItem:value,continueBtnDisabled:true});
        }
      }
    
      handleInterviewMessage = (e) => {
        let data = {...this.state.data};
        data.interviewRecruiterMessage = e.target.value;        
          this.setState({data})
        
      }
    
     handleCancel = () =>{
       window.scrollTo(0,0);
       this.setState({showModal: true});
     }
    
     handleModalCancel = () => {
       this.setState({showModal: false});
     }
    
     handleModalYes = () => {
        let data = {...this.state.data};
        data.jobId='';
        data.interviewType='';
        data.interviewDuration='';
        data.interviewLocation='';
        data.interviewMessage='';
        data.userId='';
        data.userName='';
        data.interviewRecruiterMessage='';
        data.interviewAttachments="";
        data.candidateDetails=[],
        data.slotDetails=[];
        data.requestedBy= null;
        this.setState({
          data,
          continueBtnDisabled: true,
          showModal: false,
          candidateData : [],
          currentStep: 1,
          current: this.props.date?this.props.date: new Date(),
          today: (this.props.date && this.props.date !== null) ? null :  new Date(),
          date: (this.props.date) ? this.props.date : new Date(),
          activeElement:{id:1, label: "30 mins"},
          selectedSlots:[],
          ampm: "am",
          selectedCandidates: [],
          selectAllChecked: false,
          activeId: '',
          activeItem: '',
          slotsInvalid: false,
          slotsDisabled: false,
          currentInterviewDuration: '30 mins', 
          candidateImage:null,
          candidateImageCount:0,
          calendarFirstDate: true,
          confirmModal: false,
          sentToCandidateButton: false,
          highestStepper:4,
          disableNotesSection: true,
          jobTitle: '',
          showStep1Content: true,
          jobTitleBHID: ''
        });
        this.props.history.push({
          pathname:'/recruiter/interview-scheduler',
          state:{}
        });
     }
    
     handleInterviewDuration = (id, event) => {
       let duration = SelectionBoxDurations.filter(item => item.id === id);
       let data = {...this.state.data};
       data.interviewDuration = duration[0].label;
       this.setState({activeElementId: id,data});
     }
    
     handleInterviewLocation = (e) => { 
        let data = {...this.state.data};
        data.interviewLocation = e.target.value;
        if(data.interviewLocation.length > 0 && this.state.data.interviewType.length > 0){
          this.setState({continueBtnDisabled: false,data});
        }else{
          this.setState({continueBtnDisabled: true,data});
        }
     }
    
     handleItemChange = (e,value) => {
       e.preventDefault();
       let data = {...this.state.data};
       data.interviewType = value;
       if(data.interviewType.length >0 && this.state.data.interviewLocation.length > 0){
        this.setState({data,activeId:value,activeItem:value,continueBtnDisabled:false});
       }else{
        this.setState({data,activeId:value,activeItem:value,continueBtnDisabled:true});
       }
    }
    
     step2Checking = () => {
      
     }
    
     handleSendtoCandidate = () => {
      let data = this.state.data;
      this.setState({sentToCandidateButton: true})
    
      axios.post("/galaxy/interview/" + this.state.data.interviewId, JSON.stringify(data)).then((response)=>{
        if(response.data){
          if(response.data.message === 'success'){
            window.scrollTo(0,0);
            this.setState({confirmModal: true});
          }
        }
      })
      .catch((error) => {
        ConsoleLog('error', error);
      });
    
     }
    
     handleEdit = () => {
       this.setState({showStep1Content: false});
       this.fetchProgressedCandidateList(this.state.data.jobId);
       this.setState({currentStep:1,continueBtnDisabled: false});
     }
    
     handleConfirmModal = () => {
       this.setState({confirmModal: false});
       this.props.history.push({
        pathname:'/recruiter/interview-scheduler',
        state:{}
      });
     }
     handleAttachClick = ()=> {
       this.setState({
        deleteAttachFiles: []
       });
      if(!this.state.data.jobId) {
        const data={...this.state.data};
        this.setState({data});
      } 
    }
     addFile = (file)=> {
      let progressPercent = {...this.state.progressPercent};
      progressPercent[file.name] = 0;
      this.setState({progressPercent});         
        this.uploadFile(file, 'clientInterview/' + this.state.data.interviewId +  '/' + file.name)
      .then((data)=> {
        //ConsoleLog("datakey",data.Key)
        const interviewData={...this.state.data};
        let interviewAttachments = interviewData.interviewAttachments;
        ConsoleLog('addFile deleteAttachFiles', this.state.deleteAttachFiles, !this.state.deleteAttachFiles.includes(file.name));
        if (!this.state.deleteAttachFiles.includes(file.name)) {
          interviewAttachments = interviewData.interviewAttachments ? interviewData.interviewAttachments + ';' + data.Key : data.Key;
          interviewData.interviewAttachments = interviewAttachments;
          this.setState({data:interviewData});
        }
        ConsoleLog('interviewAttachments', this.state.data.interviewAttachments);
      },
      (err) => { 
        ConsoleLog("error",err);
      });
      
    }
    
  uploadFile = (file, filePath) => {
    ConsoleLog("deletefile",this.state.deleteAttachFiles,"upfile",file);  
    AWS.config.update({
      region : config.cognito.region
    });
    
    let logins = {}
    logins['cognito-idp.'+ config.cognito.region +'.amazonaws.com/' + config.cognito.userPool] = this.props.user.storage['CognitoIdentityServiceProvider.'+ config.cognito.clientId +'.' + this.props.attributes.email + '.idToken'];
    // Add the User's Id Token to the Cognito credentials login map.
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: config.cognito.identityPool,
        Logins: logins
    });
          
    let S3 = new AWS.S3({ params: { Bucket: config.cognito.interviewBucketName }});
    // Specify the S3 upload parameters
    let params = {
      Key: filePath,
      ContentType: file.type,
      Body: file,
      // ACL: 'public-read'
    };
    
    return new Promise((resolve, reject)=> {       
      S3.upload(params).on('httpUploadProgress',  (progress)=> {
        const progressPercentage = progress.loaded/progress.total * 100;
        let progressPercent = {...this.state.progressPercent};
        progressPercent[file.name] = progressPercentage;
        this.setState({progressPercent});
      }).send( (err, data)=> {
          if (err) {
            reject(err);
          } else {     
            ConsoleLog("fileupAm",file, file.name);    
            resolve(data);
          }
      });
    });
  }

  removeFile= (filePath) => {
    AWS.config.update({
      region : config.cognito.region
    });
    
    let logins = {}
    logins['cognito-idp.'+ config.cognito.region +'.amazonaws.com/' + config.cognito.userPool] = this.props.user.storage['CognitoIdentityServiceProvider.'+ config.cognito.clientId +'.' + this.props.attributes.email + '.idToken'];
    // Add the User's Id Token to the Cognito credentials login map.
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: config.cognito.identityPool,
        Logins: logins
    });
          
    let S3 = new AWS.S3({ params: { Bucket: config.cognito.interviewBucketName }});
    // Specify the S3 upload parameters
    let params = {
      Key: filePath
      // ACL: 'public-read'
    };

    return new Promise(function(resolve, reject) {
      S3.deleteObject(params, function(err, data) {
          if (err) {
              reject(err);
          } else {              
            resolve(data);
          }
      });
    });
  }
  
  handleRemoveFile = (file) => {
    //  ConsoleLog("removeAm",file)
    const data={...this.state.data};
    const deleted = [...this.state.deleteAttachFiles];
    deleted.push(file);
    ConsoleLog("handleRemoveFile",deleted);
    var attachArray = data.interviewAttachments.split(";").filter(item => !item.includes(file));
    data.interviewAttachments = attachArray.join(";");
    this.setState({data, deleteAttachFiles:deleted});
    this.removeFile('clientInterview/' +this.state.data.interviewId +  '/' + file)
      .then((removeData)=> {
        
      },
      (err) => { 
        ConsoleLog("error",err);
      });
  }

    handlePageDataLossYes = () => {
      const { nextPath } = this.state;
      this.props.history.push(nextPath);
      this.props.onPageDataLoss(false,'');
    }
  
    handlePageDataLossCancel = () => {
      this.props.onPageDataLoss(false,'');
      this.setState({pageDataLoss: false});
    }

    render(){
      ConsoleLog("logedin user details pg", this.props);
    let stepper1Class="";
    let stepper2Class="";
    let stepper3Class="";
    let stepper4Class="";
    let content = "";
    switch(this.state.currentStep) {
        case 1:
            content = this.state.candidateData.length && this.state.candidateImageCount == this.state.candidateData.length ? <SelectCandidatesStep1 
                    pool={this.state.candidateData} 
                    handleCandidateSelect={this.handleCandidateSelect} 
                    selectedCandidates={this.state.selectedCandidates}
                    handleCheckbox={this.handleCheckbox}
                    selectAllChecked={this.state.selectAllChecked}
                    showStep1Content={this.state.showStep1Content}
                    />: null;
            stepper1Class = "active";
            break;
        case 2:
            content = <InterviewDetailsStep2 
                    handleInterviewDuration={this.handleInterviewDuration}
                    activeElementId={this.state.activeElementId}
                    handleInterviewLocation={this.handleInterviewLocation}
                    interviewLocation={this.state.data.interviewLocation}
                    handleItemChange={this.handleItemChange}
                    activeId={this.state.activeId}
                    activeItem={this.state.activeItem}
                    />;
            stepper1Class = "visited";
            stepper2Class = "active";
            break;
        case 3:
            content = <DateTimeStep3 
                    date={this.state.date} 
                    getWeekDays={this.getWeekDays}
                    isSameDay={this.isSameDay}
                    handlePreviousWeek={this.handlePreviousWeek}
                    handleNextWeek={this.handleNextWeek}
                    handleNextMonth={this.handleNextMonth}
                    handlePreviousMonth={this.handlePreviousMonth}
                    getWeekDays={this.getWeekDays}
                    isSameDay={this.isSameDay}
                    current={this.state.current}
                    handleSelect={this.handleSelect}
                    today={this.state.today}
                    selectedDates={this.state.selectedSlots}
                    isClient={true}
                    selectedSlots={this.state.selectedSlots}
                    handleAMPM={this.handleAMPM}
                    isAmPm={this.state.ampm}
                    timeSelect={this.timeSelect}
                    interviewDuration={this.state.data.interviewDuration.length>0?this.state.data.interviewDuration:"30 mins"}
                    interviewMessage={this.state.data.interviewMessage}
                    candidateLength={this.state.data.candidateDetails.length}
                    slotsInvalid={this.state.slotsInvalid}
                    slotsDisabled={this.state.slotsDisabled}
                    calendarFirstDate={this.state.calendarFirstDate}
                    disableNotesSection={this.state.disableNotesSection}
                    overlappingSlots={this.state.overlappingSlots}
                    />;
            stepper1Class = "visited";
            stepper2Class = "visited";
            stepper3Class = "active";
        break;
        case 4:
            content = <ConfirmDetailsStep4
                      {...this.state} 
                      interviewAttachments={this.state.data.interviewAttachments}
                      handleInterviewMessage={this.handleInterviewMessage}
                      interviewMessage={this.state.data.interviewRecruiterMessage}
                      progressPercent={this.state.progressPercent}
                      addFile={this.addFile}
                      handleAttachClick={this.handleAttachClick}
                      handleRemoveFile={this.handleRemoveFile}
                      userType={this.props.clientDetails.user_role ? this.props.clientDetails.user_role : null}
                      />;
            stepper1Class = "visited";
            stepper2Class = "visited";
            stepper3Class = "visited";
            stepper4Class = "active";
        break;
        default:
            content = null;
            stepper1Class = "active";
        }

        return(
          this.state.data.interviewId?
            <div className="rec-interview-container">
                <div className="selected-job-title-main">
                    <h1 className="selected-job-title">
                    <span>Interview details for </span>{this.state.jobTitle} - {this.state.jobTitleBHID}
                    </h1>
                </div>
                <div className="stepper-section-wrapper">
                    <GalaxyStepper 
                        loadData={this.loadData}
                        stepper1Class={stepper1Class}
                        stepper2Class={stepper2Class}
                        stepper3Class={stepper3Class}
                        stepper4Class={stepper4Class}
                        currentStep={this.state.currentStep}
                    />
                    <div className="stepper-content-main">
                        {this.state.data.jobId?content:null}
                    </div>
                    <div className={this.state.currentStep ===4 ?"stepper-buttons stepper4 ":"stepper-buttons"}>
                        <Button className="stepper-cancel" onClick={this.handleCancel}>Cancel</Button>
                        {/* <Button className={ this.state.continueBtnDisabled?"stepper-continue-disabled":"stepper-continue"} disabled={this.state.continueBtnDisabled} onClick={this.handleContinue}>Continue</Button> */}
                        {this.state.currentStep ===4?
                          <Fragment>
                            <Button className="stepper-edit" onClick={this.handleEdit}>Edit</Button>
                            <Button className={this.state.sentToCandidateButton?"stepper-send disabled":"stepper-send"} 
                              onClick={this.handleSendtoCandidate}
                              disabled={this.state.sentToCandidateButton}>
                            Send to Candidates</Button>
                          </Fragment>
                          : <Button className={ this.state.continueBtnDisabled?"stepper-continue-disabled":"stepper-continue"}
                             disabled={this.state.continueBtnDisabled}
                             onClick={this.handleContinue}>
                            Continue</Button>}
                    </div>
                </div>
                <Modal className="rec-interview-cancel-modal" show={this.state.showModal}>
                    <p>Are you sure you want to leave this page? Your progress will not be saved.</p>
                    <div className="delete-interview-buttons">
                    <Button className="rec-interview-cancel" onClick={this.handleModalCancel}>Cancel</Button>
                    <Button className="rec-interview-confirm" onClick={this.handleModalYes}>Yes</Button>
                    </div>
                </Modal>
                <Modal className="rec-interview-cancel-modal" show={this.state.confirmModal}>
                    <p>Your interview request has been sent successfully to your candidates.</p>
                    <div className="delete-interview-buttons">
                    <Button className="rec-interview-thankyou" onClick={this.handleConfirmModal}>Ok</Button>
                    </div>
                </Modal> 

                <Modal className="rec-interview-cancel-modal" show={this.state.pageDataLoss}>
                    <p>Are you sure you want to leave this page? Your progress will not be saved.</p>
                    <div className="delete-interview-buttons">
                    <Button className="rec-interview-cancel" onClick={this.handlePageDataLossCancel}>Cancel</Button>
                    <Button className="rec-interview-confirm" onClick={this.handlePageDataLossYes}>Yes</Button>
                    </div>
                </Modal>

            </div>
            :""
        )
    }
}

const mapStateToProps = state => {
    return {
        pool: state.talentPool.pool,
        activeCandidateId: state.talentPool.activeCandidateId,
        jobTitleId :state.talentPool.jobTitleId,
        profileInfo: state.candidateProfile.profileInfo,
        jobs: state.talentPool.jobList,
        user:state.cognito.user,
        clientDetails: state.clientProfile.clientDetails,
        companyType:state.talentPool.companyType,      
        jobTitle: state.talentPool.jobTitle,
        attributes: state.cognito.attributes, 
        jobTitleBHID: state.talentPool.jobTitleBHID,
        pageDataLoss: state.clientProfile.pageDataLoss,
        nextPath: state.clientProfile.nextPath
    };
}
  
const mapDispatchToProps = dispatch => {
    return {
        onGetTalentPool: (jobTitleId,user) => dispatch(actions.getTalentPool(jobTitleId,user)),
        onPageDataLoss: (pageData,nextPath) => dispatch(actions.setPageDataLoss(pageData,nextPath))
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(withErrorHandler(RecruiterInterviewContainer,axios));


// WEBPACK FOOTER //
// ./src/container/Recruiter/RecruiterInterviewDetails/RecruiterInterviewContainer/RecruiterInterviewContainer.js